import React from 'react';
import { FaFacebookF, FaLinkedinIn, FaWhatsapp, FaInstagram } from "react-icons/fa";
import "./footer.css";

function FooterMain() {
  return (
    <div className="footer1">

      <div className="footer-content1">
        <p className="footer-text1">
          © 2026{" "}
          <a 
            href="https://fazoacademy.com" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="footer-link1"
          >
            Fazo Academy
          </a>{" "}
          — All rights reserved.
        </p>

        <div className="social-icons mobile-socialicons">
          <a href="https://www.facebook.com/share/1G4PfTp6Bv/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" className="facebook">
            <FaFacebookF />
          </a>
          <a href="https://www.linkedin.com/company/fazo-academy/" target="_blank" rel="noopener noreferrer" className="linkedin">
            <FaLinkedinIn />
          </a>
          <a href="https://wa.me/916380866249" target="_blank" rel="noopener noreferrer" className="whatsapp">
            <FaWhatsapp />
          </a>
          <a href="https://www.instagram.com/fazo_academy?utm_source=qr&igsh=MWR3djJ4cHJsejlnOA==" target="_blank" rel="noopener noreferrer" className="instagram">
            <FaInstagram />
          </a>
        </div>
      </div>

    </div>
  );
}

export default FooterMain;
